export const CASH_DISCOUNT_CUSTOMERS_REPORT_LOADINGS = {
  GET_REPORT: "loadingCashDiscountCustomersReport"
};

export const reportCashDiscountCustomersTypes = {
  SET_CASH_DISCOUNT_CUSTOMERS_REPORT_FILTERS: "CASH_DISCOUNT_CUSTOMERS_REPORT/SET_FILTERS",
  RESTORE_INITIAL: "CASH_DISCOUNT_CUSTOMERS_REPORT/RESTORE_INITIAL",
};
